/** Which of the customer's configs a history drawer is showing */
export enum ConfigHistoryTarget {
  BACK_OFFICE = 'BACK_OFFICE',
  PLAYER_DATA = 'PLAYER_DATA',
}
